export { default } from "./Panel.view";
